<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-zh-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-zh-badge">ZigZag Heading + Primary CTA</span>

  <div class="cr-zh-row">
    <div
      class="cr-zh-dropzone"
      [appInlineMedia]="block.variables?.['ZigZagHacImage']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'ZigZagHacImage')"
    >
      <a *ngIf="block.variables?.['ZigZagHacImage']; else emptyPreview" [href]="imagePreviewHref" target="_blank" rel="noopener">
        <img [src]="block.variables?.['ZigZagHacImage']" [alt]="block.variables?.['ZigZagHacImageAlt'] || ''" />
      </a>

      <ng-template #emptyPreview>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>

    <div class="cr-zh-content">
      <span
        class="cr-zh-heading"
        [appInlineEdit]="block.variables?.ZigZagHacHeading ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert heading"
        (inlineEditChange)="onChange($event, 'ZigZagHacHeading')"
      ></span>

      <span
        class="cr-zh-text"
        [appInlineEdit]="block.variables?.ZigZagHacText ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert row text"
        [inlineEditMultiline]="true"
        (inlineEditChange)="onChange($event, 'ZigZagHacText')"
      ></span>

      <a class="cr-zh-cta" [href]="ctaPreviewHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.ZigZagHacCtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'ZigZagHacCtaText')"
        ></span>
      </a>
    </div>
  </div>
</div>

<!-- Right panel: real edit form -->
<div class="cr-zh-edit" *ngIf="!isPreview">
  <div class="cr-zh-field-row">
    <span class="cr-zh-field-label">Image</span>
    <span
      class="cr-zh-toggle"
      [class.cr-zh-toggle-on]="imageAsUpload"
      role="button"
      tabindex="0"
      [title]="imageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImageMode()"
      (keydown.enter)="toggleImageMode()"
      (keydown.space)="toggleImageMode()"
    ></span>
  </div>
  <div class="cr-zh-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['ZigZagHacImage'] ?? ''"
      (handleOnChange)="onChange($event, 'ZigZagHacImage')"
      [placeholder]="imagePlaceholder"
      variable="ZigZagHacImage"
      [isImage]="imageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-zh-empty-overlay" *ngIf="imageAsUpload && !block.variables?.['ZigZagHacImage']">
      <div class="cr-zh-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-zh-title">Upload image</div>
      <div class="cr-zh-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-zh-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['ZigZagHacImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'ZigZagHacImageHref')"
      [placeholder]="imageHrefPlaceholder"
      variable="ZigZagHacImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'ZigZagHacImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['ZigZagHacImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['ZigZagHacImageAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'ZigZagHacImageAlt')"
    [placeholder]="imageAltPlaceholder"
    [maxLength]="500"
    variable="ZigZagHacImageAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['ZigZagHacHeading'] ?? ''"
    (handleOnChange)="onChange($event, 'ZigZagHacHeading')"
    [placeholder]="headingPlaceholder"
    [maxLength]="500"
    variable="ZigZagHacHeading"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['ZigZagHacText'] ?? ''"
    (handleOnChange)="onChange($event, 'ZigZagHacText')"
    [placeholder]="textPlaceholder"
    [maxLength]="4000"
    variable="ZigZagHacText"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-zh-link-field">
    <app-field-editor-v2
      type="action-link"
      [blockData]="block.variables?.['ZigZagHacCtaLink'] ?? ''"
      (handleOnChange)="onChange($event, 'ZigZagHacCtaLink')"
      [placeholder]="ctaLinkPlaceholder"
      [maxLength]="500"
      variable="ZigZagHacCtaLink"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'ZigZagHacCtaLinkSegmentRegex')"
      [selectedSegment]="block.variables?.['ZigZagHacCtaLinkSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['ZigZagHacCtaText'] ?? ''"
    (handleOnChange)="onChange($event, 'ZigZagHacCtaText')"
    [placeholder]="ctaTextPlaceholder"
    [maxLength]="30"
    variable="ZigZagHacCtaText"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
